import { render, staticRenderFns } from "./DeliverableDropdown.vue?vue&type=template&id=668f28d3&"
import script from "./DeliverableDropdown.vue?vue&type=script&lang=js&"
export * from "./DeliverableDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('668f28d3')) {
      api.createRecord('668f28d3', component.options)
    } else {
      api.reload('668f28d3', component.options)
    }
    module.hot.accept("./DeliverableDropdown.vue?vue&type=template&id=668f28d3&", function () {
      api.rerender('668f28d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableDropdown.vue"
export default component.exports